
import { supabase } from "@/integrations/supabase/client";
import { MembershipVerificationResult } from "../types/membership";

export async function verifyMembership(
  membershipId: string,
  verificationToken: string
): Promise<MembershipVerificationResult> {
  console.log(`Vérification d'adhésion avec id=${membershipId}, token=${verificationToken}`);
  
  try {
    // Vérifier que l'adhésion existe et qu'elle correspond au token
    const { data, error } = await supabase
      .from("memberships")
      .select("*")
      .eq("id", membershipId)
      .eq("verification_token", verificationToken)
      .eq("payment_status", "pending_verification")
      .maybeSingle();
    
    if (error) {
      console.log("Erreur lors de la vérification de l'adhésion:", error);
      
      // Vérifier si l'adhésion existe mais a peut-être déjà été vérifiée
      const { data: existingMembership, error: existingError } = await supabase
        .from("memberships")
        .select("*")
        .eq("id", membershipId)
        .maybeSingle();
      
      if (!existingError && existingMembership) {
        // L'adhésion existe, mais elle a peut-être déjà été vérifiée
        if (existingMembership.payment_status === "pending_payment" || 
            existingMembership.payment_status === "paid") {
          return {
            success: true,
            membershipId,
            message: existingMembership.membership_type === "donor" 
              ? "Don déjà vérifié" 
              : "Adhésion déjà vérifiée",
            membership: existingMembership
          };
        }
      }
      
      throw new Error("Le lien de vérification est invalide ou a expiré.");
    }
    
    if (!data) {
      throw new Error("Adhésion non trouvée ou déjà vérifiée.");
    }
    
    // Mettre à jour le statut de l'adhésion
    const { error: updateError } = await supabase
      .from("memberships")
      .update({ payment_status: "pending_payment" })
      .eq("id", membershipId);
    
    if (updateError) {
      console.error("Erreur lors de la mise à jour du statut de l'adhésion:", updateError);
      
      // Vérifier si l'adhésion a déjà été mise à jour (en cas de double-clic)
      const { data: currentMembership, error: currentError } = await supabase
        .from("memberships")
        .select("*")
        .eq("id", membershipId)
        .maybeSingle();
      
      if (!currentError && currentMembership && currentMembership.payment_status === "pending_payment") {
        return {
          success: true,
          membershipId,
          message: currentMembership.membership_type === "donor" 
            ? "Don déjà vérifié" 
            : "Adhésion déjà vérifiée",
          membership: currentMembership
        };
      }
      
      throw new Error("Une erreur est survenue lors de la vérification.");
    }
    
    return {
      success: true,
      membershipId,
      message: data.membership_type === "donor" 
        ? "Don vérifié avec succès" 
        : "Adhésion vérifiée avec succès",
      membership: data
    };
  } catch (error: any) {
    console.error("Erreur lors de la vérification:", error);
    throw error;
  }
}
